import { Container } from '@mui/material';
import Page from 'src/components/page/page';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import { useBenefitsDetails } from './benefits-details.hook';
import BenefitsDetailsForm from './components/benefits-details-form';
import RegisterCodes from '../products/details/components/code-modal';
import RegisterCpfs from '../products/details/components/cpf-modal';
import RedeemsModal from '../products/details/components/redeem-modal';
import BenefitDetailsLoading from '../components/benefit-details-loading';

export default function BenefitsDetails() {
  const hook = useBenefitsDetails();

  return (
    <Page title={hook.title}>
      <Container maxWidth="xl">
        <HeaderBreadcrumbs heading={hook.title} links={[]} sx={{ mb: 3 }} />
        {hook.isDetailsLoading ? <BenefitDetailsLoading /> : <BenefitsDetailsForm hook={hook} />}
        <RegisterCodes productDetailsHook={hook} />
        <RegisterCpfs productDetailsHook={hook} />
        <RedeemsModal productHook={hook} />
      </Container>
    </Page>
  );
}
